const Renderer = require('../Renderer');
const RenderUtil = require('../RenderUtil');
const g2 = require('../../g2');
/**
 * 统计渲染基类
 * @ignore
 * @param {Object} options 构造参数
 * @param {G.Map} options.map  地图对象
 * @param {String} options.id 渲染器id
 * @param {String} options.name 渲染器名称
 * @param {Object} options.eventDispatcher 
 * @param {String} options.idField
 * @param {Object} options.featureBuilder
 * @param {String} options.geometryType
 * @param {Object} options.renderOption
 */
let renderer = Renderer.extend({
    options: {},
    initialize(options) {
        Renderer.prototype.initialize.call(this, options);
        //
        this.featureSet = new g2.sfs.FeatureSet();
        this.layer = new g2.carto.FeatureLayer({});
        this.fields = null;
    },

    /**
     * 销毁
     */
    destroy() {
        this.featureSet = null;
        this.layer = null;
    },

    /**
     * @override
     * @param list
     */
    add(list) {
        let len = list.length;
        for (let i = 0; i < len; i++) {
            let item = list[i];
            let feature = this.options.featureBuilder.buildFeature(item);
            feature._original_data = item;
            this.featureSet.add(feature);
        }
        this.layer.addFeatures(this.featureSet);
        this.render();
    },


    /**
     * @override
     * @param list
     */
    update(list) {
        let len = list.length;
        for (let i = 0; i < len; i++) {
            let item = list[i];
            let findResult = RenderUtil.getFeatureById(item[this.options.idField], this.featureSet);
            if (findResult.index >= 0) {
                this.featureSet.features.splice(findResult.index, 1);
            }
            let feature = this.options.featureBuilder.buildFeature(item);
            feature._original_data = item;
            this.featureSet.add(feature);
        }
        this.layer.addFeatures(this.featureSet);
        this.render();
    },

    /***
     *
     * @param id
     */
    remove(id) {
        this.layer.clear();
        let findResult = RenderUtil.getFeatureById(id, this.featureSet);
        if (findResult.index >= 0) {
            this.featureSet.features.splice(findResult.index, 1);
        }
        this.render();
    },

    getLayer() {
        return this.layer;
    },

    onResolutionChanged(event) {
        let zoomRange = this.options.renderOption.zoomRange || [];
        let lastRange = -1,
            newRange = -1;
        let currentLevel = Math.round(event.level);
        if (this.lastLevel == undefined) {
            this.lastLevel = currentLevel;
            return;
        }
        if (currentLevel == this.lastLevel) {
            return;
        }
        // console.debug(this.lastLevel, ',', currentLevel);
        for (let i = 0; i < zoomRange.length; i++) {
            let zoomRangeItem = zoomRange[i];
            if (currentLevel >= zoomRangeItem.range[0] && currentLevel <= zoomRangeItem.range[1]) {
                newRange = i;
            }
            if (this.lastLevel >= zoomRangeItem.range[0] && this.lastLevel <= zoomRangeItem.range[1]) {
                lastRange = i;
            }
        }
        if (newRange != lastRange) {
            this.options.eventDispatcher.fire('zoomrangechange', {
                range: zoomRange[newRange]
            });
        }
        this.lastLevel = currentLevel;
    },

    //
    initListeners() {
        this.onClick = (event) => {
            if (this.options.eventDispatcher.listens('click')) {
                this.fireEvent('click', event);
            }
        }
        this.onMouseOver = (event) => {
            if (this.options.eventDispatcher.listens('mouseover')) {
                this.fireEvent('mouseover', event);
            }
        }
        this.onMouseOut = (event) => {
            if (this.options.eventDispatcher.listens('mouseout')) {
                this.fireEvent('mouseout', event);
            }
        }
    },

    //tirgger chart event
    fireEvent(eventName, eventData) {
        let data = {};
        for (let k in eventData) {
            data[k] = eventData[k];
        }
        data.featureType = this.options.id;
        data.featureName = this.options.name;
        this.options.eventDispatcher.fire(eventName, data);
    }
});

module.exports = renderer;